/** @file Signed shoelace area of a closed ring stored as flat [x0, y0, x1, y1, …] numbers. */

/** Positive when the ring turns counter-clockwise in a y-up frame (clockwise as drawn on a y-down image). */
export function ringArea(ring: ArrayLike<number>): number {
  const n = ring.length >> 1;
  let twice = 0;
  for (let i = 0; i < n; i++) {
    const j = i === 0 ? n - 1 : i - 1;
    twice += (ring[2 * j] ?? 0) * (ring[2 * i + 1] ?? 0) - (ring[2 * i] ?? 0) * (ring[2 * j + 1] ?? 0);
  }
  return twice / 2;
}
